var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrewTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52148 18.1758L1.46094 20.4961H0.537109V3.80273L2.79297 1.39648H19.0996L21.2266 3.30859L21.5918 13.4062C21.4128 14.5807 20.7797 17.1316 19.6797 17.9395C18.5797 18.7473 9.78255 18.4336 5.52148 18.1758Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3.26544C9.93382 3.26544 9.06641 4.13285 9.06641 5.19904V9.06622C9.06641 10.1324 9.93382 10.9998 11 10.9998C12.0662 10.9998 12.9336 10.1324 12.9336 9.06622V5.19904C12.9336 4.13285 12.0662 3.26544 11 3.26544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16.1561C12.0679 16.1561 12.9336 15.2904 12.9336 14.2225C12.9336 13.1546 12.0679 12.2889 11 12.2889C9.93211 12.2889 9.06641 13.1546 9.06641 14.2225C9.06641 15.2904 9.93211 16.1561 11 16.1561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2506 0.687317H3.74941C1.70564 0.687317 0.0429688 2.34999 0.0429688 4.39376V20.6678C0.0429688 21.1617 0.576039 21.4689 1.00242 21.2302L5.45948 18.7342H18.2506C20.2944 18.7342 21.9571 17.0715 21.9571 15.0278V4.39376C21.957 2.34999 20.2944 0.687317 18.2506 0.687317ZM20.668 15.0278C20.668 16.3607 19.5836 17.4451 18.2506 17.4451H5.2913C5.18104 17.4451 5.07259 17.4734 4.97638 17.5273L1.33203 19.5681V4.39376C1.33203 3.06082 2.41643 1.97638 3.74941 1.97638H18.2506C19.5835 1.97638 20.668 3.06078 20.668 4.39376V15.0278Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrewTick);
export default __webpack_public_path__ + "static/media/crewTick.f2694a99a572b297fed1627b0e45e085.svg";
export { ForwardRef as ReactComponent };